export default __webpack_public_path__ + "static/media/static_docs_tutorials_commonroad_io_tutorial.cdbbcd64.zip";